// 터치 누름 칸 최소 크기 계산(순수 함수). 창이 zoom(배율 u)으로 줄면 CSS 최소 높이를 그만큼 키워 화면 겉 크기를 44px 이상으로 지킨다(출시 게이트 RG-008).
export const TOUCH_MIN_PX = 44;

/** 배율 u(zoom)에서 겉 크기가 44px 이상이 되는 CSS 최소 크기(px). u가 이상하면 배율 1로 본다 */
export function touchMinCssPx(u: number): number {
  const s = Number.isFinite(u) && u > 0 ? u : 1;
  return Math.ceil((TOUCH_MIN_PX / s) * 10) / 10;
}
